// Formatting/style constants shared across the event-card family
// (EventsSectionCard, EventDetailFields, EventDetailMobileCard).

export const INTERPUNCT = ' · ';
export const CARD_RADIUS = 'rounded-input';

// `text-nav` is 15px at 1.4, so both pair it with `leading-normal` to reach
// the design's 1.5. Use these rather than a `text-[15px]`.
export const CARD_TITLE_CLASS = 'font-inter text-nav font-semibold leading-normal text-off-black';

// Colour is left to the call site.
export const CARD_BODY_CLASS = 'font-inter text-nav font-normal leading-normal';

// Not the pickup-alerts capacity alert, which looks similar but is semibold
// behind a 9px solid disc.
export const ALERT_PILL_CLASS =
  'flex items-center gap-1 self-start rounded-xs bg-chilli-blush p-2 font-inter text-xs font-normal leading-tight text-chilli-red';

export function toSentenceCase(value: string): string {
  return value
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
